var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-card bg-white p-4 h-100"},[_c('div',{staticClass:"text-muted small text-uppercase font-weight-bold mb-2"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"display-4 font-weight-bold text-primary mb-2"},[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"text-secondary"},[_vm._v(_vm._s(_vm.hint))])])
}
var staticRenderFns = []

export { render, staticRenderFns }